import * as THREE from 'three'
import React from 'react'
import { useGLTF } from '@react-three/drei'
import { GLTF } from 'three-stdlib'
import { frontBasicMaterial } from '../utils/materials'

type GLTFResult = GLTF & {
  nodes: {
    hops: THREE.Mesh
    wood_stick: THREE.Mesh
    grass: THREE.Mesh
    trees: THREE.Mesh
  }
}

export const Hops = (props: any) => {
  const { nodes } = useGLTF(require('../assets/3D/hops.glb')) as GLTFResult
  return (
    <group {...props} dispose={null} >
      <mesh geometry={nodes.hops.geometry} material={frontBasicMaterial} />
      <mesh geometry={nodes.wood_stick.geometry} material={frontBasicMaterial} />
      <mesh geometry={nodes.grass.geometry} material={frontBasicMaterial} />
      <mesh geometry={nodes.trees.geometry} material={frontBasicMaterial} />
    </group>
  )
}

useGLTF.preload(require('../assets/3D/hops.glb'))
